import React from 'react';
import './MGTTheme.scss';

const MGTTheme = () => (
  <div className="product-hero-decoration" aria-hidden="true">
    <div className="product-hero-decoration-left" />
    <div className="product-hero-decoration-right" />
  </div>
);

export default MGTTheme;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductHero/Theme/MGT/index.js